import type { ButtonHTMLAttributes } from 'react';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & { variant?: 'primary' | 'secondary' };

export function Button({ variant = 'primary', className = '', ...rest }: Props) {
  const base =
    'w-full rounded-xl px-4 py-3 text-base font-medium active:opacity-80 disabled:opacity-50 min-h-[44px]';
  const look = variant === 'primary' ? 'bg-button text-button-text' : 'bg-secondary-bg text-link';
  return <button type="button" className={`${base} ${look} ${className}`} {...rest} />;
}
